import { render, staticRenderFns } from "./SelectPermission.vue?vue&type=template&id=4687f40c&"
import script from "./SelectPermission.vue?vue&type=script&lang=js&"
export * from "./SelectPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports